import { getAssetTypePrefixBySystemType } from '@innovyze/lib_asset_schema';

// Generate the map layer ID from the asset and system type.
// Ported from @innovyze/map-components (src/utils/helpers.ts) so lib-am-common
// no longer depends on that package.
export const getMapLayerId = (
	assetType: string,
	systemType: string,
): string => {
	// Split the systemType on the uppercase and join with a _ to get the systemTypeName
	const systemTypeName = systemType.split(/(?=[A-Z])/).join('_');
	// Remove the system type prefix and replace non-alphabetic characters with an underscore
	const layerName = assetType
		.replace(
			new RegExp(`^(${getAssetTypePrefixBySystemType(systemType)})`),
			'',
		)
		.replace(/([^a-z]+)/gi, '_');

	return `${systemTypeName}_${layerName}`.toLowerCase();
};
